// ABOUTME: Simple divider line for tooltip content sections
// ABOUTME: Provides visual separation between tooltip sections

import { memo } from "react"

interface TooltipDividerProps {
  className?: string
}

export const TooltipDivider = memo(({ className = "" }: TooltipDividerProps) => (
  <div className={`my-2 h-[1px] w-[80%] bg-gray-600 ${className}`} />
))

TooltipDivider.displayName = "TooltipDivider"
